import { unwrap } from "@majourneys/api-client";
import { api } from "../../../lib/api";

export const seoLookupApi = {
  cityBySlug: async (slug: string) =>
    unwrap(await api.cities["by-slug"]({ slug }).get()),
  categoryBySlug: async (slug: string) =>
    unwrap(await api.categories["by-slug"]({ slug }).get()),
};
